/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMatiereReferentielGridDto } from './FcbMatiereReferentielGridDto';
import {
    FcbMatiereReferentielGridDtoFromJSON,
    FcbMatiereReferentielGridDtoFromJSONTyped,
    FcbMatiereReferentielGridDtoToJSON,
} from './FcbMatiereReferentielGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMatiereReferentielGridDtoPaginatedResults
 */
export interface FcbMatiereReferentielGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMatiereReferentielGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMatiereReferentielGridDto>}
     * @memberof FcbMatiereReferentielGridDtoPaginatedResults
     */
    results?: Array<FcbMatiereReferentielGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMatiereReferentielGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMatiereReferentielGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMatiereReferentielGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMatiereReferentielGridDtoPaginatedResultsFromJSON(json: any): FcbMatiereReferentielGridDtoPaginatedResults {
    return FcbMatiereReferentielGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMatiereReferentielGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMatiereReferentielGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMatiereReferentielGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMatiereReferentielGridDtoPaginatedResultsToJSON(value?: FcbMatiereReferentielGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMatiereReferentielGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

